export { default as ENTRY } from './entry';

const base = '/specialties';
const optional = '(/:specialtyId)';

export const ROOT_PATH = base;
export const PATH = `${base}${optional}`;
export const BasePaths = [PATH];
export const pageName = 'Specialty Directory';
export const GA_CATEGORY = 'SpecialtyDirectory';

export const getPathForSpecialty = specialtyId => `${base}/${specialtyId}`;

export const SortingEnum = {
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
};

export const PARAMS = {
    DEBUG: 'debug',
    PAGE_COUNT: 'pageCount',
    PAGE_INDEX: 'page',
    SCOPE: 'scope',
    SPECIALTY: 'specialty',
    SORT_BY: 'sort',
};

export const DEFAULT_PARAM_VALUES = {
    [PARAMS.DEBUG]: false,
    [PARAMS.PAGE_INDEX]: 0,
    [PARAMS.SORT_BY]: SortingEnum.LAST_NAME,
};
